import React from 'react';
import './AuthPages.css';

function AuthLayout(props) {
    return (
        <main className="auth-page">
            <section className="auth-page-content">
                <div className="auth-page-grid">
                    <div className="auth-page-intro">
                        <img src="/img/logo.png" alt="NeuraTrader" className="auth-page-logo" />
                        <h1 className="auth-page-title">NeuraTrader Admin</h1>
                        <p className="auth-page-subtitle">
                            Manage users, plans, symbols, and system settings for the trading platform.
                        </p>
                        <ul className="auth-page-features">
                            <li>
                                <span className="auth-page-feature-dot" aria-hidden="true" />
                                Monitor active bots, users, and exchange connections
                            </li>
                            <li>
                                <span className="auth-page-feature-dot" aria-hidden="true" />
                                Configure plan limits and system alerts
                            </li>
                            <li>
                                <span className="auth-page-feature-dot" aria-hidden="true" />
                                Review logs and keep the platform healthy
                            </li>
                        </ul>
                    </div>

                    <div className="auth-card">
                        <div className="auth-card-header">
                            <h2 className="auth-card-title">{props.title}</h2>
                            {props.description ? (
                                <p className="auth-card-description">{props.description}</p>
                            ) : null}
                        </div>
                        {props.children}
                    </div>
                </div>
            </section>
        </main>
    );
}

export default AuthLayout;